<template>
	<footer>
		<h6>北京易才博普奥管理顾问有限公司 版权所有 Copyright © 2018 All Rights Reserved <a href="https://beian.miit.gov.cn/" class="footic">京ICP备11033355号</a></h6>
		<h6>地址：北京市朝阳区下甸甲3号院尚8广告园1号楼A座</h6>
	</footer>
</template>

<script>
export default {
		name: "myfoot",
		data() {
			return {

			}
		},
		
	
	}
  
</script>

<style scoped lang="less">
	footer {		    
		width: 1084px;
		height: 92px;
		text-align: center;
		h6 {
			font-size: 12px;
			color: #a3a3a7;
			margin-bottom: 8px;
		}
		h6:first-child {
			padding-top: 30px;
		}
		.footic{
			color: #a3a3a7;

		}
		.footic:hover{
			 cursor: pointer;
              color: #ffffff;
		}
	}
</style>